import { B as Badge, d as defineCustomElement$1 } from './badge.js';

const TtBadge = Badge;
const defineCustomElement = defineCustomElement$1;

export { TtBadge, defineCustomElement };
